if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[name="add"][type="submit"]') || this.querySelector('[type="submit"]:not([data-vr-buy-now])');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.buyNowButton = this.querySelector('[data-vr-buy-now]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      connectedCallback() {
        this.vrVariantDisabled = this.submitButton.disabled;
        this.vrRefreshCart = () => { if (this.isConnected) void this.syncCartState(); };
        this.vrResume = () => { if (!document.hidden) this.vrRefreshCart(); };
        window.addEventListener('pageshow', this.vrRefreshCart);
        window.addEventListener('focus', this.vrRefreshCart);
        window.addEventListener('vr:cart-changed', this.vrRefreshCart);
        window.addEventListener('storage', this.vrRefreshCart);
        document.addEventListener('visibilitychange', this.vrResume);
        this.vrUnsubscribeCart = typeof subscribe === 'function' ? subscribe(PUB_SUB_EVENTS.cartUpdate, this.vrRefreshCart) : null;
        this.vrRefreshCart();
      }

      disconnectedCallback() {
        window.removeEventListener('pageshow', this.vrRefreshCart);
        window.removeEventListener('focus', this.vrRefreshCart);
        window.removeEventListener('vr:cart-changed', this.vrRefreshCart);
        window.removeEventListener('storage', this.vrRefreshCart);
        document.removeEventListener('visibilitychange', this.vrResume);
        this.vrUnsubscribeCart?.();
      }

      async syncCartState() {
        const sequence = this.vrCartSequence = (this.vrCartSequence || 0) + 1;
        const variant = String(this.variantIdInput.value);
        try {
          const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {credentials:'same-origin',cache:'no-store'});
          if (!response.ok) return;
          const cart = await response.json();
          if (sequence !== this.vrCartSequence || !this.isConnected) return;
          if (variant !== String(this.variantIdInput.value)) { this.vrRefreshCart(); return; }
          this.paintCartState(cart.items.some(item => String(item.variant_id) === variant));
        } catch { /* Keep the current stock state when the cart cannot be read. */ }
      }

      paintCartState(inCart) {
        this.vrInCart = inCart;
        this.submitButton.classList.toggle('vr-product-in-cart', inCart);
        if (inCart) {
          this.submitButton.disabled = true;
          this.submitButton.setAttribute('aria-disabled','true');
          this.submitButtonText.textContent = document.documentElement.lang.startsWith('it') ? 'AGGIUNTO AL CARRELLO' : document.documentElement.lang.startsWith('fr') ? 'DÉJÀ DANS LE PANIER' : 'ADDED TO CART';
        } else if (!this.vrVariantDisabled) {
          this.submitButton.disabled = false;
          this.submitButton.removeAttribute('aria-disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        const buyNow = !!evt.submitter?.hasAttribute('data-vr-buy-now');
        const access=window.VRAccountAccess;
        if(buyNow){
          if(!access||this.vrAuthBusy)return;
          this.vrAuthBusy=true;
          try{if(!await access.require({intent:'purchase',purchase:{variant:String(this.variantIdInput.value),quantity:parseInt(this.form.querySelector('[name="quantity"]')?.value)||1},trigger:evt.submitter}))return;}
          finally{this.vrAuthBusy=false;}
        }
        if (this.vrInCart) {
          if (buyNow && !this.vrVariantDisabled) window.location.assign((window.Shopify?.routes?.root || '/') + 'checkout');
          return;
        }
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        let checkoutStarted = false;
        if (this.buyNowButton) this.buyNowButton.disabled = true;
        if (buyNow) this.buyNowButton.classList.add('loading');

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart && !buyNow) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        const variantId = formData.get('id');
        const quantity = parseInt(formData.get('quantity')) || 1;
        const linesUpdateDeferred = this.createCartLinesUpdateEvent(variantId, quantity);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: variantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              this.dispatchCartErrorEvent(response.description || response.message, 'INVALID');
              linesUpdateDeferred?.reject(new Error(response.description || response.message));

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (buyNow) {
              this.resolveCartLinesUpdate(linesUpdateDeferred);
              checkoutStarted = true;
              window.location.assign((window.Shopify?.routes?.root || '/') + 'checkout');
              return;
            } else if (!this.cart) {
              if(!document.querySelector('script[data-vr-account-access]')?.dataset.signedIn?.includes('true'))try{sessionStorage.setItem('vr_account_cart_prompt_v1','1');}catch{}
              this.resolveCartLinesUpdate(linesUpdateDeferred);
              window.location = window.routes.cart_url;
              return;
            }

            this.resolveCartLinesUpdate(linesUpdateDeferred);
            this.paintCartState(true);
            window.dispatchEvent(new Event('vr:cart-changed'));
            window.dispatchEvent(new Event('vr:cart-added'));
            try { localStorage.setItem('vr_cart_changed_v1', String(Date.now())); } catch {}

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: variantId,
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            if (buyNow) this.handleErrorMessage(document.documentElement.lang.startsWith('it') ? 'Non è stato possibile avviare l’acquisto. Riprova tra poco.' : 'We could not start checkout. Please try again shortly.');
            console.error(e);
            this.dispatchCartErrorEvent(e.message || 'Network error', 'SERVICE_UNAVAILABLE');
            linesUpdateDeferred?.reject(e);
          })
          .finally(() => {
            if (this.buyNowButton) {
              this.buyNowButton.classList.remove('loading');
              this.buyNowButton.disabled = checkoutStarted || this.vrVariantDisabled;
            }
            if (checkoutStarted) return;
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            this.vrRefreshCart?.();
            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        this.vrVariantDisabled = disable;
        this.vrInCart = false;
        if (this.buyNowButton) this.buyNowButton.disabled = disable;
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      createCartLinesUpdateEvent(variantId, quantity) {
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return null;

        const deferred = CartLinesUpdateEvent.createPromise();
        this.dispatchEvent(
          new CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: [{ merchandiseId: variantId, quantity }],
            promise: deferred.promise,
          })
        );
        return deferred;
      }

      resolveCartLinesUpdate(deferred) {
        if (!deferred) return;
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return;

        const pendingCartDataPromise = typeof CartItems !== 'undefined'
          ? CartItems.fetchCartData()
          : fetch(`${routes.cart_url}.json`).then((response) => response.json());

        pendingCartDataPromise
          .then((cart) => {
            if (!cart?.currency) return deferred.reject(new Error('Missing currency in cart response'));
            deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart) });
          })
          .catch((e) => deferred.reject(e));
      }

      dispatchCartErrorEvent(message, code) {
        const { CartErrorEvent } = window.StandardEvents || {};
        if (!CartErrorEvent) return;
        this.dispatchEvent(new CartErrorEvent({ error: message, code }));
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
